import { render, staticRenderFns } from "./CardsEditForm.vue?vue&type=template&id=309682ba&scoped=true"
import script from "./CardsEditForm.vue?vue&type=script&lang=js"
export * from "./CardsEditForm.vue?vue&type=script&lang=js"
import style0 from "./CardsEditForm.vue?vue&type=style&index=0&id=309682ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309682ba",
  null
  
)

export default component.exports